import {
  SET_TOP_BANNER_IMAGE_PATH,
  SET_TITLE,
  SET_SUBTITLE
} from './constants';

export const setTopBannerImagePath = url => ({
  type: SET_TOP_BANNER_IMAGE_PATH,
  payload: url
});

export const setTitle = title => ({
  type: SET_TITLE,
  payload: title
});

export const setSubTitle = subTitle => ({
  type: SET_SUBTITLE,
  payload: subTitle
});



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/actionTypes.js